import React, { useState } from "react";

import { IFolderAgGrid } from "@mctypes/global.types";
import { Flex, Paper, Stack, Title } from "@mantine/core";
import { EditSaveAbort, HSpace } from "../../../../../components";
import BIM360FolderSelector from "../../../../../components/Bim360FolderSelector/BIM360FolderSelector";
import CheckOrWarn from "../../../../../components/CheckOrWarn";

const Bim360OutputFolderSelector: React.FC<{
  projectId: string;
  bim360ProjectId: string;
  isValid: boolean;
  currentFolder: IFolderAgGrid;
  onSave: (folderAg: IFolderAgGrid) => void;
}> = ({ projectId, bim360ProjectId, isValid, onSave, currentFolder }) => {
  const [selectedFolder, setSelectedFolder] = useState<IFolderAgGrid>(null);
  const [editMode, setEditMode] = useState(false);

  const folderSelected = (folderAg: IFolderAgGrid) => {
    setSelectedFolder(folderAg);
  };

  const saveAndExit = () => {
    if (selectedFolder.id != null && selectedFolder.name != null) {
      onSave(selectedFolder);
    }
    setEditMode(false);
  };

  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff" style={{ display: "flex" }}>
      <Stack gap="xs" w="100%">
        <Title order={4} fw={400}>
          <CheckOrWarn bool={isValid} />
          Eksportmappe: {currentFolder.name}
        </Title>
        <Title order={6} fw={400} c="dimmed">
          Velg mappe hvor eksporten skal plasseres
        </Title>
        {editMode === false && <i className="fa fa-pencil fa-fw editIcon" onClick={() => setEditMode(true)} />}
        {editMode === true && (
          <Flex direction="column" style={{ height: "600px" }}>
            <BIM360FolderSelector
              onSelectedAgFolderUrn={folderSelected}
              bim360ProjectId={bim360ProjectId}
              projectId={projectId}
            />
            <HSpace />
            <EditSaveAbort editMode={editMode} saveCb={saveAndExit} editModeCb={() => setEditMode(false)} />
          </Flex>
        )}
      </Stack>
    </Paper>
  );
};

export default Bim360OutputFolderSelector;
